import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, Message } from 'primeng/api';
import { Table } from 'primeng/table';
import { ConsumoFolha } from 'src/app/admihair/api/dto/consumo-folha';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { ConsumoFolhaService } from 'src/app/admihair/service/consumo-folha.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';
import { AdmihairBaseComponent } from '../../../admihair-base.component';

@Component({
  selector: 'app-consumo-listar',
  templateUrl: './consumo-listar.component.html',
  styleUrls: ['./consumo-listar.component.scss']
})
export class ConsumoListarComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;
  loading: boolean = true;
  empresaSelecionada?: Empresa;
  filtroDataRegistro?: Date;
  consumos: ConsumoFolha[] = [];

  constructor(private consumoFolhaService: ConsumoFolhaService,
    
    private confirmationService: ConfirmationService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    erroService: ErroService,
    utilStorageService: UtilStorageService) {
      super(erroService, utilStorageService)
     }



  ngOnInit(): void {
    this.empresaSelecionada = this.getEmpresa();
    this.verificarPermissoes();
    this.inicializarCompetenciaAtual();
    if (this.permissaoListar) {
      this.listarConsumos();
    }
  }
  
  inicializarCompetenciaAtual(){
    const now = new Date()
    this.filtroDataRegistro = new Date(now.getFullYear(), now.getMonth(), 1);
  }
  
  listarConsumos(){
    this.loading = true;
    this.consumoFolhaService.listarPorEmpresaIdECompetencia(this.empresaSelecionada?.id, this.filtroDataRegistro).subscribe({
      next: (data: ConsumoFolha[]) => {
        this.consumos = data;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    })
  }




  excluir(id: number){
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.consumoFolhaService.excluir(id).subscribe({
          next: () => {
            this.exibirMensagemSucesso();
            this.listarConsumos();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        })
        
      }
    });
  }


  editar(id: number) {
    this._router.navigate(["/apps/consumo/editar/" + id], { relativeTo: this._activatedRoute })
  }

  detalhar(id: number) {
    this._router.navigate(["/apps/consumo/detalhar/" + id], { relativeTo: this._activatedRoute })
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  verificarPermissoes() {
    this.permissaoListar = this.verificarPermissao('PERM_LISTAR_CONSUMO');
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_CONSUMO');
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_CONSUMO');
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_CONSUMO');
    this.permissaoExcluir = this.verificarPermissao('PERM_EXCLUIR_CONSUMO');
  }

}
